import {ClearOutlined} from '@ant-design/icons'
import {DraftIconButton, useAiContext} from '../core'

export const ButtonClearContext = props => {
    const ai = useAiContext()
    const onClick = () => ai.clearContext()

    return (
        <DraftIconButton
            title="清空会话上下文"
            onClick={onClick}
            {...props}
        >
            <ClearOutlined />
        </DraftIconButton>
    )
}
